import { useEffect } from 'react';
import { getDocsUrlForRedirect } from '../utils/docsLink';

const FaqRedirectPage = () => {
  const docsUrl = getDocsUrlForRedirect();

  useEffect(() => {
    window.location.replace(docsUrl);
  }, [docsUrl]);

  return (
    <div className="flex h-[60vh] items-center justify-center px-4 text-center">
      <a href={docsUrl} className="text-blue-400 hover:text-blue-300">
        Open documentation
      </a>
    </div>
  );
};

export default FaqRedirectPage;
